// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oMyHI","title":"styles_title__wZa8E"};